module.exports = __webpack_public_path__ + "static/project-8a-d2f9b6a2c165221fa30fbb4b0acd522d.png";